// import Storage from './Storage';
import Util from './util';
import { Toast } from 'antd-mobile/lib';
import { hashHistory } from 'react-router';
import store from './ReduxStore.js';
import {isLogin} from './action/loginAction';
import {goLogin} from './getPay'
import Guide from './components/guidePage'
window.tokenTimeLong=15*60*1000
window.tokenTimeshort=10*60*1000
const fetchTimeout = 30;
/*
  &改写fetch，加入超时机制
*/
const oldFetch = fetch;
window.fetch = (input,opts)=>{
  let fetchPromise = oldFetch(input,opts);
  let timeoutPromise = new Promise((resolve,reject)=>{
    setTimeout(()=>{
      reject(new Error("fetch timeout"))
    }, opts && opts.timeout ? opts.timeout * 1000 : fetchTimeout * 1000)
  })
  return Promise.race([fetchPromise,timeoutPromise])
}
let ua=navigator.userAgent.toLowerCase()

// var storage = new Storage({
//   // 最大容量，默认值1000条数据循环存储
//   size: 1000,
//   // 存储引擎：对于RN使用AsyncStorage，对于web使用window.localStorage
//   // 如果不指定则数据只会保存在内存中，重启后即丢失
  
//   // 数据过期时间，默认一整天（1000 * 3600 * 24 毫秒），设为null则永不过期
//   //defaultExpires: 1000 * 3600 * 24,
//   defaultExpires: null,
//   // 读写时在内存中缓存数据。默认启用。
//   enableCache: true,
//   // 如果storage中没有相应数据，或数据已过期，
//   // 则会调用相应的sync方法，无缝返回最新数据。
//   // sync方法的具体说明会在后文提到
//   // 你可以在构造函数这里就写好sync的方法
//   // 或是写到另一个文件里，这里require引入
//   // 或是在任何时候，直接对storage.sync进行赋值修改
//   sync: {}
// })

// global.storage = storage;
//i为时间 如果没有传入i则为用不过期
export function setStorage(keyId,data,i){
  // if(i == undefined){
  //   i = null
  // }
  // let key = keyId;
  // let id = undefined;
  // if(keyId.indexOf('-') != -1){
  //   let parts = keyId.split('-');
  //   key = parts[0];
  //   id = parts[1];
  // }
  // storage.save({
  //     key: key, 
  //     data: data,
  //     expires: i,
  //     id: id
  //   });
  if (Object.prototype.toString.call(data)!=="[object Null]") {
    localStorage.setItem(keyId,JSON.stringify(data))
  }else{
    localStorage.setItem(keyId,data)
  }

}

export const goHome=(enterType)=>{
    let ua=navigator.userAgent.toLowerCase()
    if (ua.indexOf("amcfmapp")>-1) {
        if (ua.indexOf("wkwebview")>-1) {
            if (window.webkit) {
              window.webkit.messageHandlers.amcfm_utils.postMessage({"refreshHome":"intelInvest"});
              window.webkit.messageHandlers.amcfm_utils.postMessage({"finish":""});
            }
        }else{
            if (window.amcfm_utils) {
              window.amcfm_utils.refreshHome('intelInvest');
              window.amcfm_utils.finish();
            }
        }
    }else{
        hashHistory.go(1-window.historyData.length);
        if (sessionStorage.app_index.split(',')[0]!="#/") {
          setTimeout(()=>{
            hashHistory.replace({
               pathname:`/${enterType?'?enterType='+enterType:''}` ,
            })
          },300)
        }
    }
}
//Token会通过回调函数返回。
export function getStorage(keyId,callback){
  let key = keyId;
  let id = undefined;
  if(keyId.indexOf('-') != -1){
    let parts = keyId.split('-');
    key = parts[0];
    id = parts[1];
  }
  if(!callback)
  return new Promise((resolev, reject)=>{
    let ret=localStorage.getItem(keyId);
    let a=new Date();
    //登录超时不在app生效
    if (keyId=='loginState'&&ua.indexOf("amcfmapp")==-1) {
      if (JSON.parse(localStorage.getItem('tokenTimeLong'))<a.getTime()) {
        // window.localStorage.removeItem('currentUserInfo');
        // window.localStorage.removeItem('loginInfo-longToken');
        // window.localStorage.removeItem('loginInfo-shortToken');
        // window.localStorage.removeItem('loginState');
        window.clearLocalStorage();
        store.dispatch(isLogin(false));
        resolev('0')
        return;
      }//当前时间是否超过长token有效期，超过时间清空缓存 刷新 页面
    }
    if(keyId == 'loginInfo-shortToken' ){
      //如果在管家打开 判断短token是否过期  不是管家打开判断长token是否过期
      if (ua.indexOf("amcfmapp")>-1) {
        if (JSON.parse(localStorage.getItem('tokenTimeshort'))>a.getTime()) {
            if (ret) {
              resolev(JSON.parse(ret))
              return;
            }
        }
      }else{
        if (JSON.parse(localStorage.getItem('tokenTimeshort'))>a.getTime()) {
          store.dispatch(isLogin(true));
          if (ret) {
            resolev(JSON.parse(ret))
            return;
          }
        }else{
          if (JSON.parse(localStorage.getItem('tokenTimeLong'))!=null&&JSON.parse(localStorage.getItem('tokenTimeLong'))<a.getTime()) {
              // window.localStorage.clear();
              window.clearLocalStorage();
              document.location.href='index.html';   
              reject(new Error(key + 'is expired' + ' 过期'));
          }
        }
      }
      let url = Util.url + "/api/account/getShortTokenByLong";
      let longToken = JSON.parse(localStorage.getItem('loginInfo-longToken'));
      if(longToken == null){
        reject(new Error(key + 'is expired' + ' longTOken丢失'));
        return
      }
      Util.get(url, { longToken }, (dataToken)=>{
        console.log('换token')
        if(dataToken.code === '0000'){
          setStorage('loginInfo-shortToken', dataToken.content.token);
          setStorage('tokenTimeshort', a.getTime()+window.tokenTimeshort);
          setStorage('tokenTimeLong', a.getTime()+window.tokenTimeLong);
          resolev(dataToken.content.token);
        }else{
          reject(new Error(key + ' is expired' + ' 服务器没有返回新token'));
        }
      }, (err)=>{
        reject(new Error(key + ' is expired' + ' 请检查当前网络'));
      });
      return;
    };
    if (ret) {
      resolev(JSON.parse(ret))
    } else {
      resolev(9999)
    }
  //   storage.load({
  //   key: key,
  //   id: id,
  //   // autoSync(默认为true)意味着在没有找到数据或数据过期时自动调用相应的sync方法
  //   autoSync: true,
  //   // syncInBackground(默认为true)意味着如果数据过期，
  //   // 在调用sync方法的同时先返回已经过期的数据。
  //   // 设置为false的话，则始终强制返回sync方法提供的最新数据(当然会需要更多等待时间)。
  //   syncInBackground: true,
  //   // 你还可以给sync方法传递额外的参数
  //   syncParams: {
  //     extraFetchOptions: {
  //       // 各种参数
  //     },
  //     someFlag: true,
  //   },
  //   }).then(ret => {
  //     // 如果找到数据，则在then方法中返回
  //     // 注意：这是异步返回的结果（不了解异步请自行搜索学习）
  //     // 你只能在then这个方法内继续处理ret数据
  //     // 而不能在then以外处理
  //     // 也没有办法“变成”同步返回
  //     // 你也可以使用“看似”同步的async/await语法
  //     resolev(ret);
  //     //this.setState({ user: ret });
  //   }).catch(async err => {
  //     //如果没有找到数据且没有sync方法，
  //     //或者有其他异常，则在catch中返回
  //   //console.warn(err.message,"***********");
  //   console.log(err.message,"***********");

  //   console.log(err.name);

  //   switch (err.name) {
  //       case 'NotFoundError':
  //         reject(new Error('Not found ' + key));
  //         // TODO;
  //         break;
  //       case 'ExpiredError':
  //           // TODO
  //         if(key == 'loginInfo' && id == 'shortToken'){
  //           let url = urlAllBase + "/api/account/getShortTokenByLong";
  //           let longToken=''
  //           if(longToken == ''){
  //             reject(new Error(key + 'is expired' + ' longTOken丢失'));
  //           }
  //           Util.get(url, { longToken }, (dataToken)=>{
  //             if(dataToken.code === '0000'){
  //               setStorage('loginInfo-shortToken', dataToken.content.token, tokenTime);
  //               resolev(dataToken.content.token);
  //             }else{
  //               console.log(dataToken.message);
  //               reject(new Error(key + ' is expired' + ' 服务器没有返回新token'));
  //             }
  //           }, (err)=>{
  //             console.log(err);
  //             console.log('没有取到short');
  //             reject(new Error(key + ' is expired' + ' 请检查当前网络'));
  //           });
  //           break;
  //         }
  //         reject(new Error(key + ' is expired'));
            
  //           // setTimeout(function(){
  //           //   storage.save({
  //           //     key: "syncFunction",  // "loginState" 注意:请不要在key中使用_下划线符号!
  //           //     rawData:"新的短Token",//{ from: 'some other site',userid: 'some userid',token: 'some token'},
  //           //     // 如果不指定过期时间，则会使用defaultExpires参数
  //           //     // 如果设为null，则永不过期
  //           //     expires: 1000*3
  //           //   });
  //           //   callback("新的短Token")
  //           // },1)
  //           break;
  //       default:
  //           reject(new Error('Not found ' + key));
  //   }
  // })
  });
  // storage.load({
  //   key: key,
  //   id: id,
  //   // autoSync(默认为true)意味着在没有找到数据或数据过期时自动调用相应的sync方法
  //   autoSync: true,
  //   // syncInBackground(默认为true)意味着如果数据过期，
  //   // 在调用sync方法的同时先返回已经过期的数据。
  //   // 设置为false的话，则始终强制返回sync方法提供的最新数据(当然会需要更多等待时间)。
  //   syncInBackground: true,
  //   // 你还可以给sync方法传递额外的参数
  //   syncParams: {
  //     extraFetchOptions: {
  //       // 各种参数
  //     },
  //     someFlag: true,
  //   },
  //   }).then(ret => {
  //     // 如果找到数据，则在then方法中返回
  //     // 注意：这是异步返回的结果（不了解异步请自行搜索学习）
  //     // 你只能在then这个方法内继续处理ret数据
  //     // 而不能在then以外处理
  //     // 也没有办法“变成”同步返回
  //     // 你也可以使用“看似”同步的async/await语法
  //     callback(ret)
  //     //this.setState({ user: ret });
  //   }).catch(async err => {
  //     //如果没有找到数据且没有sync方法，
  //     //或者有其他异常，则在catch中返回
  //   //console.warn(err.message,"***********");
  //   console.log(err.message,"***********");
  //   console.log(err.name)
  //   switch (err.name) {
  //       case 'NotFoundError':
  //         callback(null)
  //         // TODO;
  //         break;
  //       case 'ExpiredError':
  //           // TODO
  //           if(id != 'shortToken' || key != 'loginInfo'){
  //             callback(null);
  //             break;
  //           }
  //           let url = urlAllBase + "/api/account/getShortTokenByLong";
  //           let longToken = await getTempInfo('longToken');
  //           if(longToken == ''){
  //             callback(null);
  //             break;
  //           }
  //           Util.get(url, { longToken }, (dataToken)=>{
  //             if(dataToken.code === '0000'){
  //               setStorage('loginInfo-shortToken', dataToken.content.token, tokenTime);
  //               callback(dataToken.content.token);
  //             }else{
  //               console.log(dataToken.message);
  //               callback(null);
  //             }
  //           }, (err)=>{
  //             console.log(err);
  //             console.log('没有取到short');
  //             callback(null);
  //           });
  //           // setTimeout(function(){
  //           //   storage.save({
  //           //     key: "syncFunction",  // "loginState" 注意:请不要在key中使用_下划线符号!
  //           //     rawData:"新的短Token",//{ from: 'some other site',userid: 'some userid',token: 'some token'},
  //           //     // 如果不指定过期时间，则会使用defaultExpires参数
  //           //     // 如果设为null，则永不过期
  //           //     expires: 1000*3
  //           //   });
  //           //   callback("新的短Token")
  //           // },1)
  //           break;
  //       default:
  //           callback(null);
  //   }
  // })
}

export const getTempInfo = async (key) => {
  let result = '';
  try{
    if(key === 'shortToken' || key === 'longToken'){
      key = 'loginInfo-' + key;
    }
    result = await getStorage(key);
  }catch(err){
    return '';
  }
  return result;
}

/* 合并两个对象 */
export const mergeObjectEasy = (oldObj, newObj)=>{
  return Object.assign({}, oldObj, newObj);
}


/* 同步更新当前用户信息和用户列表信息*/
export const syncAddUserInfo = async (userInfo)=>{
  let currentInfo = await getTempInfo('currentUserInfo');
  if(currentInfo){
    let newInfo = mergeObjectEasy(currentInfo, userInfo);
    setStorage('currentUserInfo', newInfo);
    setStorage('userList-' + currentInfo.userId, newInfo);
  }
}
export const fundDetailFun = (type, code, route) => {
    if(type == "G") {
      hashHistory.push({
        pathname: '/PublicOffering',
        state:{
          fundCode:code
        },
        query:{
          fundCode:code
        }
      });
    }else if(type == "S") {
      let newCallback = ()=>{
        hashHistory.push({
          pathname: '/PrivatePlacement',
          state:{
            fundCode:code
          },
          query:{
            fundCode:code
          }
        });
      }
      goLogin(newCallback,route);
    }else if(type == "S_ZX") {
      hashHistory.push({
        pathname: '/PrivatePlacement',
        state:{
          fundCode:code
        },
        query:{
          fundCode:code
        }
      });
    }else if(type == "J") {
      let newCallback = ()=>{
        hashHistory.push({
          pathname: '/Details',
          state:{
            fundCode:code
          },
          query:{
            fundCode:code
          }
        });
      }
      goLogin(newCallback,route);
    }else if(type == "Z") {
      let newCallback = ()=>{
        hashHistory.push({
          pathname: '/Details',
          state:{
            fundCode:code
          },
          query:{
            fundCode:code
          }
        });
      }
      goLogin(newCallback,route);
    }
  }


  export const allMonetaryCode = {
    ordinary:["SF1002"],
}

export const isAllMonetaryCode = (code) =>{
    let flag = false
    for(let i=0;i<allMonetaryCode.ordinary.length; i++){
        if(code == allMonetaryCode.ordinary[i]){
            flag = true
            break
        }
    }
    return flag
}

export const isRate = (money) =>{
    console.log(money,"moneymoney",money > 200000)
    let rateNum = ""
    if((money - 200000)<0){
      rateNum = 1
    }else if((money - 1000000) <= 0){
      rateNum = 0.8
    }else if((money - 5000000) <= 0){
      rateNum = 0.6
    }else{
      rateNum = 0.4
    }
    return rateNum
}
//智投组合费率 11.5
export const superFundCodeFee = (code) =>{
  if (code == "SF1012") {
    return "0.2%";
  }else if(code == "SF1014"){
    return "0.3%";
  }else if(code == "SF1015"){
    return "0.25%";
  }else if(code == "SF1013" || code ==  "SF1016" || code ==  "SF1017" || code == "SF1019" || code == "SF1020" || code == "SF1021"){
    return "0.5%";
  }else if(code == "SF1018"){
    return "0.4%"
  }else if(code == "SF1036"){
    return "0.25%"
  }
}

export const traceSaveParams = {
  traceAction: {
    MAX_RISK: 'MAX_RISK',
    READ_TIPS: 'READ_TIPS',
    TRADE_REFUSE: 'TRADE_REFUSE',
    BUY_RISK_WARN_FIRST: 'BUY_RISK_WARN_FIRST',
    BUY_WARN_AGAIN: 'BUY_WARN_AGAIN',
    REGISTER_PROTOCOL:'REGISTER_PROTOCOL',
    SYNC_ACCOUNT_PROTOCOL:'SYNC_ACCOUNT_PROTOCOL',
    CERTIFICATION_PROTOCOL:'CERTIFICATION_PROTOCOL',
    SPECIAL_TIP:'SPECIAL_TIP',
    SF_SPECIAL_TIP:'SF_SPECIAL_TIP',
  },
  appName: 'HXCF_H5',
  appVersion: navigator.appVersion,
  deviceName: navigator.appName,
  deviceType: "",
  os: navigator.platform,
  deviceId: ""
}

export const getToastConfPoint = (funcObj) => {
  return {
    duration: funcObj && funcObj.duration ? funcObj.duration : 1500,
    position: funcObj && funcObj.position ? funcObj.position : 0,
    shadow: funcObj && funcObj.shadow ? funcObj.shadow : true,
    animation: funcObj && funcObj.animation ? funcObj.animation : true,
    hideOnPress: funcObj && funcObj.hideOnPress ? funcObj.hideOnPress : true,
    delay: funcObj && funcObj.delay ? funcObj.delay : 0,
    onShow:
      funcObj && funcObj.onShow
        ? funcObj.onShow
        : () => {
          /* calls on toast\`s appear animation start*/
        },
    onShown:
      funcObj && funcObj.onShown
        ? funcObj.onShown
        : () => {
          /* calls on toast\`s appear animation end.*/
        },
    onHide:
      funcObj && funcObj.onHide
        ? funcObj.onHide
        : () => {
          /* calls on toast\`s hide animation start.*/
        },
    onHidden:
      funcObj && funcObj.onHidden
        ? funcObj.onHidden
        : () => {
          /* calls on toast\`s hide animation end.*/
        },
  };
};

export const ClassfundFun = ( code,stcode,nav, route, callback) => {
  console.log(nav)
  nav.replace({
    pathname: `/NewPublicOffering`,
    query:{
      fundCode:code
    } 
  })
}

export const onMiniProgramDialog = (type) => {
  if (navigator.userAgent.includes('miniProgram')) {
    // Guide.show(type)//弹窗图片拦截
    hashHistory.push({//页面图片拦截
      pathname:'/imgPage',
      state:{
        type: type
      },
    })
    return true
  }
  
  return false
}



// WEBPACK FOOTER //
// ./src/common.js